



// import React, { useEffect, useState } from "react";
// import {
//   Box, Button, Typography, Grid, Paper, Table, TableContainer,
//   TableHead, TableBody, IconButton, Dialog, DialogTitle,
//   DialogContent, DialogActions, Card, CardContent, MenuItem,
//   Autocomplete, TextField, Checkbox, FormControlLabel,
// } from "@mui/material";
// import { StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import dayjs from "dayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import deliveryChallanService from "../../../services/deliveryChallan.Service";
// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import suplierMasterService from "../../../services/masters/supplierMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import customerPoService from "../../../services/customerPo.Service";
// import salesOrderService from "../../../services/sales_order";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";

// // ── Styles ────────────────────────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px", color: "#718096", mb: 2,
//   display: "flex", alignItems: "center", gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex", alignItems: "center",
//   justifyContent: "space-between", mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px", fontWeight: 700, color: "#000",
//   display: "flex", alignItems: "center", gap: "10px",
// };

// const backBtnSx = {
//   display: "flex", alignItems: "center", gap: "6px",
//   fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
//   padding: "7px 14px", border: "1.5px solid #2B6CB0",
//   borderRadius: "7px", background: "#fff", textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
//   border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E", padding: "12px 22px",
//   display: "flex", alignItems: "center", gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "20px 22px" };

// const fieldLabelSx = {
//   fontSize: "12px", fontWeight: 600, color: "#2063b6",
//   mb: "4px", display: "flex", alignItems: "center", gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa", height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readOnlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const datePickerSx = {
//   width: "100%",
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa", height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//   },
//   "& input": { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" },
// };

// const formFooterSx = {
//   padding: "18px 24px", background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex", alignItems: "center",
//   justifyContent: "flex-end", gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#4CAF50",
//   color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
//   textTransform: "none", borderRadius: "8px",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#E53E3E",
//   color: "#fff", border: "none", textTransform: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px", fontWeight: 600, borderRadius: "8px",
// };

// const tableHeadCellSx = {
//   background: "#1C3A5E", color: "#fff",
//   fontSize: "12px", fontWeight: 600,
//   fontFamily: "'Inter', Arial, sans-serif",
//   whiteSpace: "nowrap",
// };

// const tableCellInputSx = {
//   "& .MuiInput-root": {
//     fontSize: "12px",
//     "&:before": { borderBottom: "none" },
//     "&:after": { borderBottom: "none" },
//     "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
//   },
//   "& input": { fontSize: "12px", padding: "4px 6px" },
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const formatDate = (date, inputFormat = null, outputFormat = "DD/MM/YYYY") => {
//   if (!date) return "";
//   const parsed = inputFormat ? dayjs(date, inputFormat) : dayjs(date);
//   return parsed.isValid() ? parsed.format(outputFormat) : "";
// };

// const DeliveryChallanAdd = () => {
//   const { handleSubmit } = useForm();
//   const navigate = useNavigate();
//   const urlLocation = useLocation();
//   const editData = urlLocation?.state;

//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const loggedInDepotId = userInfo.depot_id;
//   const from_depot_id = userInfo.depot_id;

//   const [dcType, setDcType] = useState(
//     editData ? (editData.to_depot_id ? "Depot" : editData.type || "Customer") : "Customer"
//   );

//   const [driver, setDriver] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [vehicle, setVehicle] = useState([]);
//   const [customer, setCustomer] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [schedule_entry, setScheduleEntry] = useState([]);
//   const [sales_order, setSalesOrder] = useState([]);
//   const [filteredPOs, setFilteredPOs] = useState([]);
//   const [filteredSOs, setFilteredSOs] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedCylinders, setSelectedCylinders] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [depot_name, setDepot_name] = useState([]);
//   const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(false);
//   const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(false);

// useEffect(() => {
//   async function fetchData() {
//     try {
//       const [
//         driverData, depotData, productData, customerData, vehicleData,
//         supplierData, scheduleEntryData, salesOrderData, cylinderData,
//         delivercylindrData, deliverydepotData, deliverycustomer,
//       ] = await Promise.all([
//         driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//         depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//         productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//         customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//         vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//         suplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
//         customerPoService.getScheduleEntryList({ page: 0, size: 999, searchKey: "" }),
//         salesOrderService.getsalesorder({ page: 0, size: 999, searchKey: "" }),
//         cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//         deliveryChallanService.getDeliverycylindernoList(depot_id),
//         deliveryChallanService.getDeliveryChallandepotList(depot_id),
//         deliveryChallanService.getDeliveryChallanCustomerList(depot_id),
//       ]);

//       // ... existing setters same rahenge
//       const mergedDepotData = deliverydepotData.map(dd => ({
//         ...dd,
//         depot_name: depotData.find(d => d.depot_id === dd.depot_id)?.depot_name || "Unknown Depot",
//       }));
//       setDriver(driverData);
//       setDepot(mergedDepotData);
//       setProduct(productData);
//       setVehicle(vehicleData);
//       setSupplier(supplierData);
//       setScheduleEntry(scheduleEntryData);
//       setSalesOrder(salesOrderData);
//       setCylinder(delivercylindrData);
//       setDepot_name(depotData);
//       setCustomer(deliverycustomer);

//       if (editData) {
//         // ... existing editData logic same rahega
//       }

//       // ✅ DC No Generation — sirf new entry ke liye
//      if (!editData) {
//   const dcList = await deliveryChallanService.getDeliveryChallanList({
//     page: 0, size: 5, searchKey: "", depot_id: depot_id,
//   });

//   const yr = dayjs();
//   const finYear = yr.month() >= 3
//     ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
//     : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

//   // ✅ Same fin_year ki entries filter karo
//   const sameYearEntries = dcList?.filter(d => d.entry_no?.includes(finYear)) ?? [];
//   console.log("sameYearEntries:", sameYearEntries);

//   const lastEntryNo = sameYearEntries?.[0]?.entry_no ?? "";
//   console.log("lastEntryNo:", lastEntryNo);

//   const parts = String(lastEntryNo).split("/");
//   const lastSeq = parseInt(parts[parts.length - 1]) || 0;
//   const nextSeq = lastSeq + 1;

//   const formattedEntryNo = `DC/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
//   console.log("Generated DC No:", formattedEntryNo);

//   setData(prev => ({
//     ...prev,
//     entry_no: formattedEntryNo,
//     fin_year: finYear,
//   }));
// }

//     } catch (error) { console.error("Data fetching failed", error); }
//   }
//   fetchData();
// }, []);

//   const [data, setData] = useState({
//     entry_no: editData?.entry_no || "",
//     entry_date: editData ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
//     so_no: editData?.so_no || "",
//     so_date: editData?.so_date ? formatDate(editData.so_date, null, "YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
//     po_no: editData?.po_no || "",
//     po_date: editData?.po_date ? formatDate(editData.po_date, null, "YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
//     to_depot_id: editData?.to_depot_id || "",
//     to_customer_id: editData?.to_customer_id || "",
//     vehicle_id: editData?.vehicle_id || "",
//     driver_id: editData?.driver_id || "",
//     driver_name: editData?.driver_name || "",
// vehicle_no: editData?.vehicle_no || "",
//     prepared_by: editData?.prepared_by || userInfo.full_name,
//     table_details: editData?.table_details || "",
//     delivery_address: editData?.delivery_address || "",
//     contact_no: editData?.contact_no || "",
//     invoice_no: editData?.invoice_no || "",
//     fin_year: editData?.fin_year || "",
//     from_depot_id: editData?.from_depot_id || "",
//     unregistered_driver: editData?.unregistered_driver || "",
//     unregistered_vehicle: editData?.unregistered_vehicle || "",
//     type: editData?.dcType || "",
//   });

//   const [isUpdateArray, setIsUpdateArray] = useState(false);
//   const [table_details, setTable_details] = useState(() => {
//     if (editData) {
//       try { return JSON.parse(editData.table_details); }
//       catch { return [{ sr_no: "", cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }]; }
//     }
//     return [{ sr_no: "", cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }];
//   });

//   useEffect(() => {
//     if (editData) {
//       let newData = { ...editData };
//       const prodId = editData.prod_id || editData.product_id;
//       if (prodId) {
//         const foundProduct = product.find(p => p.prod_id === prodId);
//         if (foundProduct) {
//           newData.prod_code = foundProduct.prod_code;
//           newData.product_description = foundProduct.prod_description;
//         }
//       }
//       setData(prev => ({ ...prev, ...newData }));
//     }
//   }, [editData, product]);

//   useEffect(() => {
//     setData(prev => ({ ...prev, type: dcType === "Depot" ? "depot" : "customer" }));
//   }, [dcType]);

//   const loggedInDepot = depot.find(d => d.depot_id === loggedInDepotId);

//   useEffect(() => {
//     if (!editData && loggedInDepot) {
//       setData(prev => ({ ...prev, depot_id: loggedInDepotId, depot: loggedInDepot.depot_name || "Unknown Depot" }));
//     }
//   }, [editData, loggedInDepotId, loggedInDepot]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     let updatedFields = { [name]: value };

//     if (["entry_date", "po_date", "so_date"].includes(name)) {
//       updatedFields[name] = value ? formatDate(value, null, "YYYY-MM-DD") : "";
//       if (name === "entry_date" && value) {
//         const d = new Date(value);
//         const m = d.getMonth(), y = d.getFullYear();
//         updatedFields.fin_year = m >= 3 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//       }
//     }
//     if (name === "prod_code") {
//       const p = product.find(p => p.prod_code === value);
//       updatedFields.product_description = p?.prod_description || "";
//       updatedFields.product_id = p?.prod_id || "";
//     }
//     if (name === "to_customer_id") {
//       const c = customer.find(c => c.cust_id === value);
//       if (c) {
//         setFilteredPOs(schedule_entry.filter(po => po.customer_id === value || po.cust_id === value));
//         updatedFields = { ...updatedFields, to_customer_id: c.cust_id, to_customer: c.cust_name, po_no: "", po_date: "", so_no: "", so_date: "", delivery_address: c.cust_address || "", contact_no: c.contact_no || "", invoice_no: c.invoice_no || "" };
//       }
//     }
//     if (name === "po_no") {
//       const po = filteredPOs.find(po => po.po_no === value);
//       if (po) {
//         setFilteredSOs(sales_order.filter(so => (so.customer_id === data.to_customer_id || so.cust_id === data.to_customer_id) && so.po_no === value));
//         updatedFields = { ...updatedFields, po_date: formatDate(po.po_date, null, "YYYY-MM-DD") };
//         if (!editData || editData.po_no !== value) { updatedFields.so_no = ""; updatedFields.so_date = ""; }
//       }
//     }
//     if (name === "so_no") {
//       const so = filteredSOs.find(so => so.so_no === value);
//       if (so) updatedFields.so_date = formatDate(so.so_date, null, "YYYY-MM-DD");
//     }
//     if (name === "driver_id") {
//       const d = driver.find(d => d.driver_id === value);
//       updatedFields.driver_name = d ? d.driver_name : "";
//     }
//     if (name === "vehicle_id") {
//       const v = vehicle.find(v => v.vehicle_id === value);
//       updatedFields.vehicle_no = v ? v.vehicle_no : "";
//     }
//     setData(prev => ({ ...prev, ...updatedFields }));
//   };

//   const handleChangeInput = (e, i) => {
//     const array = [...table_details];
//     array[i] = { ...array[i], [e.target.name]: e.target.value, sr_no: i + 1 };
//     setTable_details(array);
//     setIsUpdateArray(p => !p);
//   };

//   const handleRemoveDC = (index) => {
//     const values = [...table_details];
//     const removedCyl = values[index].cyl_no;
//     values.splice(index, 1);
//     setTable_details(values);
//     setSelectedCylinders(prev => prev.filter(c => c.cylinder_no !== removedCyl));
//     setIsUpdateArray(p => !p);
//   };

//   const handleAddRow = () => {
//     setTable_details(prev => [...prev, { sr_no: prev.length + 1, cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }]);
//   };

//   const handleCylinderSelect = (cyl) => {
//     const already = selectedCylinders.find(c => c.cylinder_no === cyl.cylinder_no);
//     setSelectedCylinders(already
//       ? selectedCylinders.filter(c => c.cylinder_no !== cyl.cylinder_no)
//       : [...selectedCylinders, { cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_id: cyl.prod_id, prod_code: cyl.prod_code, productDescription: cyl.prod_description || "", qty: cyl.qty || "1", bill_qty: "", uom: cyl.uom || "CUM", tag_no: cyl.tag_no || "", owner: cyl.owner || "",  status: cyl.status, level: cyl.level ?? cyl.note ?? "", note: cyl.level ?? cyl.note ?? ""}]
//     );
//   };

//   const handleDialogConfirm = () => {
//     setTable_details(selectedCylinders.map((cyl, i) => ({
//       sr_no: i + 1, cyl_id: cyl.cyl_id, prod_id: cyl.prod_id,
//       cyl_no: cyl.cylinder_no, tag_no: cyl.tag_no, owner: cyl.owner || "",prod_code: cyl.prod_code,
//       product_description: cyl.productDescription, qty: cyl.qty,
//       bill_qty: "", uom: cyl.uom, status: cyl.status, level: cyl.level ?? cyl.note ?? "", note: cyl.level ?? cyl.note ?? "",
//     })));
//     setIsUpdateArray(p => !p);
//     setOpenDialog(false);
//   };

//   const validategetForm = () => {
//     const hasError =
//       (dcType === "Customer" && !data.to_customer_id) ||
//       (dcType === "Depot" && !data.to_depot_id) ||
//       (!data.vehicle_id && !data.unregistered_vehicle) ||
//       (!data.driver_id && !data.unregistered_driver) ||
//       !data.prod_code || !data.invoice_no ||
//       table_details.filter(row => row.cyl_no && row.cyl_no.trim() !== "").length === 0 ||
//       table_details.some(row => row.cyl_no && row.cyl_no.trim() !== "" && (!row.bill_qty || parseFloat(row.bill_qty) <= 0));
//     return hasError ? ["Error! Please fill all required fields properly."] : [];
//   };

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const onSubmit = async () => {
//     if (isSubmitting) return;
//     const errors = validategetForm();
//     if (errors.length > 0) {
//       setSuccessMessage(errors.join(", "));
//       setOpenSnackbar(true);
//       setTimeout(() => { setOpenSnackbar(false); setSuccessMessage(""); }, 5000);
//       return;
//     }
//     setIsSubmitting(true);
//     const dcData = {
//       ...data, entry_id: editData ? editData.entry_id : undefined,
//       modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//       modified_by: editData ? userInfo.user_id : null,
//       created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//       created_by: editData ? editData.created_by : userInfo.user_id,
//       table_details: JSON.stringify(table_details || []),
//       changedUpdatedValue: "edit", unit_id, short_code, from_depot_id,
//       update_check: checkboxValue,
//     };
//     try {
//       editData
//         ? await deliveryChallanService.editDeleteDeliveryChallan(dcData)
//         : await deliveryChallanService.addDeliveryChallan(dcData);
//       setSuccessMessage(editData ? "Delivery Challan updated successfully" : "Delivery Challan added successfully");
//       setOpenSnackbar(true);
//       setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 2000);
//     } catch (error) {
//       setSuccessMessage("Error saving delivery challan");
//       setOpenSnackbar(true);
//       setTimeout(() => { setOpenSnackbar(false); }, 3000);
//       setIsSubmitting(false);
//     }
//   };

//   const calculateTotalCylinders = () => table_details.filter(r => r.cyl_no && r.cyl_no.trim() !== "").length;
//   const calculateTotalQuantity = () => table_details.reduce((t, r) => t + (parseFloat(r.bill_qty) || 0), 0);

//   const toggleUnregisteredDriver = () => {
//     setShowUnregisteredDriver(p => !p);
//     if (showUnregisteredDriver) handleChange({ target: { name: "unregistered_driver", value: "" } });
//   };
//   const toggleUnregisteredVehicle = () => {
//     setShowUnregisteredVehicle(p => !p);
//     if (showUnregisteredVehicle) handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>
//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Delivery Challan</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <LocalShippingIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} DELIVERY CHALLAN
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* ── Delivery Challan Details Card ── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>DELIVERY CHALLAN DETAILS</Typography>
//             </Box>

//             <Box sx={formBodySx}>
//               {/* Two-column container — same as Cylinder Inward */}
//               <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//                 {/* ════ LEFT COLUMN ════ */}
//                 <Grid
//                   item xs={12} md={6}
//                   sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}
//                 >
//                   <Grid container spacing={1.5}>

//                     {/* From Location */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>From Location</Typography>
//                       <TextField size="small" fullWidth
//                         value={depot_name.find(d => d.depot_id === loggedInDepotId)?.depot_name || "Unknown Depot"}
//                         sx={readOnlyInputSx}
//                         InputProps={{ readOnly: true }}
//                       />
//                     </Grid>

//                     {/* To Location Type */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>To Location Type</Typography>
//                       <Autocomplete
//                         disablePortal options={["Customer", "Depot"]} value={dcType}
//                         onChange={(_, newVal) => {
//                           setDcType(newVal);
//                           setData(prev => ({
//                             ...prev, type: newVal === "Depot" ? "depot" : "customer",
//                             to_supplier: "", to_supplier_id: "", to_customer_id: "", to_depot_id: "",
//                             po_no: "", po_date: "", so_no: "", so_date: "",
//                             delivery_address: "", contact_no: "", invoice_no: "",
//                           }));
//                         }}
//                         renderInput={params => (
//                           <TextField {...params} size="small" fullWidth sx={inputSx}
//                             inputProps={{ ...params.inputProps, readOnly: true }}
//                           />
//                         )}
//                       />
//                     </Grid>

//                     {/* Customer or Depot */}
//                     {dcType === "Customer" ? (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>Customer <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                         <Autocomplete
//                           disablePortal options={customer || []}
//                           getOptionLabel={opt => typeof opt === "string" ? opt : opt.cust_name || ""}
//                           value={customer.find(c => c.cust_id === data.to_customer_id) || null}
//                           onChange={(_, newVal) => handleChange({ target: { name: "to_customer_id", value: newVal?.cust_id ?? null } })}
//                           isOptionEqualToValue={(opt, val) => opt.cust_id === val?.cust_id}
//                           renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
//                         />
//                       </Grid>
//                     ) : (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>Depot <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                         <Autocomplete
//                           disablePortal options={depot || []}
//                           getOptionLabel={opt => typeof opt === "string" ? opt : opt.depot_name || ""}
//                           value={depot.find(d => d.depot_id === data.to_depot_id) || null}
//                           onChange={(_, newVal) => handleChange({ target: { name: "to_depot_id", value: newVal ? newVal.depot_id : null } })}
//                           isOptionEqualToValue={(opt, val) => opt.depot_id === val?.depot_id}
//                           renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
//                         />
//                       </Grid>
//                     )}

//                     {/* Delivery Address — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>Delivery Address</Typography>
//                         <TextField size="small" fullWidth name="delivery_address"
//                           value={data.delivery_address || ""} sx={readOnlyInputSx}
//                           InputProps={{ readOnly: true }}
//                         />
//                       </Grid>
//                     )}

//                     {/* Contact No — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>Contact No</Typography>
//                        <TextField
//   size="small"
//   fullWidth
//   name="contact_no"
//   value={data.contact_no || ""}
//   onChange={handleChange}
//   sx={inputSx} // ya readOnlyInputSx agar sirf styling hai
// />
//                       </Grid>
//                     )}

//                     {/* Driver Name */}
                   

//                     {/* Select Cylinders Button */}
//                     <Grid item xs={12}>
//                       <Button
//                         variant="contained"
//                         onClick={() => setOpenDialog(true)}
//                         startIcon={<AddIcon />}
//                         sx={{
//                           background: "#2B6CB0", color: "#fff", fontWeight: 600,
//                           fontSize: "13px", px: 3, height: "36px", borderRadius: "8px",
//                           textTransform: "none", "&:hover": { background: "#04407d" },
//                         }}
//                       >
//                         Select Cylinders
//                       </Button>
//                     </Grid>

//                   </Grid>
//                 </Grid>

//                 {/* ════ RIGHT COLUMN ════ */}
//                 <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC" }}>
//                   <Grid container spacing={1.5}>

//                     {/* DC No */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>DC No</Typography>
//                       <TextField size="small" fullWidth name="entry_no"
//                         value={data.entry_no} sx={readOnlyInputSx}
//                         InputProps={{ readOnly: true }} placeholder="Auto-generated"
//                       />
//                     </Grid>

//                     {/* DC Date */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>DC Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                       <DatePicker format="DD/MM/YYYY"
//                         value={data.entry_date ? dayjs(data.entry_date) : null}
//                         onChange={v => handleChange({ target: { name: "entry_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                         sx={datePickerSx}
//                         slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
//                       />
//                     </Grid>

//                     {/* PO No — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>PO No</Typography>
//                         <Autocomplete disablePortal options={filteredPOs} clearIcon={false}
//                           getOptionLabel={opt => typeof opt === "string" ? opt : opt.po_no || ""}
//                           value={filteredPOs.find(po => po.po_no === data.po_no) || (editData?.po_no ? { po_no: editData.po_no } : null)}
//                           onChange={(_, v) => handleChange({ target: { name: "po_no", value: v ? v.po_no : "" } })}
//                           isOptionEqualToValue={(opt, val) => opt.po_no === val.po_no}
//                           renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
//                         />
//                       </Grid>
//                     )}

//                     {/* PO Date — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>PO Date</Typography>
//                         <DatePicker format="DD/MM/YYYY"
//                           value={data.po_date ? dayjs(data.po_date) : null}
//                           onChange={v => handleChange({ target: { name: "po_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                           sx={datePickerSx}
//                           slotProps={{ textField: { size: "small", fullWidth: true } }}
//                         />
//                       </Grid>
//                     )}

//                     {/* SO No — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>SO No</Typography>
//                         <Autocomplete disablePortal options={filteredSOs} clearIcon={false}
//                           disabled={!data.po_no}
//                           getOptionLabel={opt => typeof opt === "string" ? opt : opt.so_no || ""}
//                           value={filteredSOs.find(so => so.so_no === data.so_no) || (editData?.so_no ? { so_no: editData.so_no } : null)}
//                           onChange={(_, v) => handleChange({ target: { name: "so_no", value: v ? v.so_no : "" } })}
//                           isOptionEqualToValue={(opt, val) => opt.so_no === val.so_no}
//                           renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
//                         />
//                       </Grid>
//                     )}

//                     {/* SO Date — Customer only */}
//                     {dcType === "Customer" && (
//                       <Grid item xs={12} sm={6}>
//                         <Typography sx={fieldLabelSx}>SO Date</Typography>
//                         <DatePicker format="DD/MM/YYYY"
//                           value={data.so_date ? dayjs(data.so_date) : null}
//                           onChange={v => handleChange({ target: { name: "so_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
//                           sx={datePickerSx}
//                           slotProps={{ textField: { size: "small", fullWidth: true } }}
//                         />
//                       </Grid>
//                     )}


//                      <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Driver Name</Typography>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         <Autocomplete freeSolo disablePortal options={driver || []} clearIcon={false} sx={{ flex: 1 }}
//   getOptionLabel={opt => typeof opt === "string" ? opt : opt.driver_name || ""}
//   value={driver.find(d => d.driver_id === data.driver_id) || data.driver_name || null}
//   onChange={(_, newValue) => {
//     if (newValue && typeof newValue === "object") {
//       handleChange({ target: { name: "driver_id", value: newValue.driver_id } });
//       handleChange({ target: { name: "driver_name", value: newValue.driver_name } });
//       handleChange({ target: { name: "unregistered_driver", value: "" } });
//     } else if (typeof newValue === "string") {
//       handleChange({ target: { name: "driver_id", value: "" } });
//       handleChange({ target: { name: "driver_name", value: newValue } });
//       handleChange({ target: { name: "unregistered_driver", value: newValue } });
//     } else {
//       handleChange({ target: { name: "driver_id", value: "" } });
//       handleChange({ target: { name: "driver_name", value: "" } });
//       handleChange({ target: { name: "unregistered_driver", value: "" } });
//     }
//   }}
//   onInputChange={(event, inputValue, reason) => {
//     if (reason === "input") {
//       const matched = driver.find(d => d.driver_name?.toLowerCase() === inputValue?.toLowerCase());
//       if (!matched) {
//         handleChange({ target: { name: "driver_id", value: "" } });
//         handleChange({ target: { name: "driver_name", value: inputValue } });
//         handleChange({ target: { name: "unregistered_driver", value: inputValue } });
//       }
//     }
//   }}
//   isOptionEqualToValue={(opt, val) => opt.driver_id === val?.driver_id}
//   renderInput={params => (
//     <TextField {...params} size="small" fullWidth placeholder="Select or type driver name" sx={inputSx} />
//   )}
// />
//                         {/* <IconButton onClick={toggleUnregisteredDriver} sx={{ border: "1px solid #2B6CB0", borderRadius: "8px", p: "6px", width: "36px", height: "36px" }}>
//                           <AddIcon sx={{ fontSize: 18, color: "#2B6CB0" }} />
//                         </IconButton> */}
//                       </Box>
//                       {/* {showUnregisteredDriver && (
//                         <Box sx={{ mt: 1 }}>
//                           <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unregistered Driver</Typography>
//                           <TextField size="small" fullWidth name="unregistered_driver"
//                             value={data.unregistered_driver || ""}
//                             onChange={e => { handleChange(e); if (e.target.value) handleChange({ target: { name: "driver_id", value: "" } }); }}
//                             sx={inputSx} placeholder="Enter driver name"
//                           />
//                         </Box>
//                       )} */}
//                     </Grid>

//                     {/* Vehicle No */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Vehicle No</Typography>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                        <Autocomplete freeSolo disablePortal options={vehicle || []} clearIcon={false} sx={{ flex: 1 }}
//   getOptionLabel={opt => typeof opt === "string" ? opt : opt.vehicle_no || ""}
//   value={vehicle.find(v => v.vehicle_id === data.vehicle_id) || data.vehicle_no || null}
//   onChange={(_, newValue) => {
//     if (newValue && typeof newValue === "object") {
//       handleChange({ target: { name: "vehicle_id", value: newValue.vehicle_id } });
//       handleChange({ target: { name: "vehicle_no", value: newValue.vehicle_no } });
//       handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//     } else if (typeof newValue === "string") {
//       handleChange({ target: { name: "vehicle_id", value: "" } });
//       handleChange({ target: { name: "vehicle_no", value: newValue } });
//       handleChange({ target: { name: "unregistered_vehicle", value: newValue } });
//     } else {
//       handleChange({ target: { name: "vehicle_id", value: "" } });
//       handleChange({ target: { name: "vehicle_no", value: "" } });
//       handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//     }
//   }}
//   onInputChange={(event, inputValue, reason) => {
//     if (reason === "input") {
//       const matched = vehicle.find(v => v.vehicle_no?.toLowerCase() === inputValue?.toLowerCase());
//       if (!matched) {
//         handleChange({ target: { name: "vehicle_id", value: "" } });
//         handleChange({ target: { name: "vehicle_no", value: inputValue } });
//         handleChange({ target: { name: "unregistered_vehicle", value: inputValue } });
//       }
//     }
//   }}
//   isOptionEqualToValue={(opt, val) => opt.vehicle_id === val?.vehicle_id}
//   renderInput={params => (
//     <TextField {...params} size="small" fullWidth placeholder="Select or type vehicle no" sx={inputSx} />
//   )}
// />

//                         {/* <IconButton onClick={toggleUnregisteredVehicle} sx={{ border: "1px solid #2B6CB0", borderRadius: "8px", p: "6px", width: "36px", height: "36px" }}>
//                           <AddIcon sx={{ fontSize: 18, color: "#2B6CB0" }} />
//                         </IconButton> */}
//                       </Box>
//                       {/* {showUnregisteredVehicle && (
//                         <Box sx={{ mt: 1 }}>
//                           <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unregistered Vehicle</Typography>
//                           <TextField size="small" fullWidth name="unregistered_vehicle"
//                             value={data.unregistered_vehicle || ""}
//                             onChange={e => { handleChange(e); if (e.target.value) handleChange({ target: { name: "vehicle_id", value: "" } }); }}
//                             sx={inputSx} placeholder="Enter vehicle number"
//                           />
//                         </Box>
//                       )} */}
//                     </Grid>

//                     {/* Invoice No */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Invoice No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                       <TextField size="small" fullWidth name="invoice_no"
//                         value={data.invoice_no} onChange={handleChange}
//                         placeholder="Enter invoice number" sx={inputSx}
//                       />
//                     </Grid>

//                     {/* Prepared By */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Prepared By</Typography>
//                       <TextField size="small" fullWidth name="prepared_by"
//                         value={data.prepared_by} sx={readOnlyInputSx}
//                         InputProps={{ readOnly: true }}
//                       />
//                     </Grid>

//                     {/* Product Code */}
//                     <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Product Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                       <Autocomplete disablePortal options={product || []} clearIcon={false}
//                        componentsProps={{
//                           popper: {
//                             placement: "bottom-start",
//                             modifiers: [{ name: "flip", enabled: false }],
//                           },
//                         }}
//                         getOptionLabel={opt => typeof opt === "string" ? opt : opt.prod_code || ""}
//                         value={product.find(p => p.prod_code === data.prod_code) || (data.prod_code ? { prod_code: data.prod_code } : null)}
//                         onChange={(_, v) => handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } })}
//                         isOptionEqualToValue={(opt, val) => opt.prod_code === val.prod_code}
//                         renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
//                       />
//                     </Grid>

//                     {/* Product Description */}
//                     {/* <Grid item xs={12} sm={6}>
//                       <Typography sx={fieldLabelSx}>Product Description</Typography>
//                       <TextField size="small" fullWidth name="product_description"
//                         value={data.product_description || ""} sx={readOnlyInputSx}
//                         InputProps={{ readOnly: true }}
//                       />
//                     </Grid> */}

//                   </Grid>
//                 </Grid>

//               </Grid>
//             </Box>
//           </Box>

//           {/* ── Cylinder Table ── */}
//           <Box sx={formCardSx}>
//             <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: "none" }}>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <StyledTableRow>
//                     <StyledTableCell align="center" sx={tableHeadCellSx} width="6%">Sr No</StyledTableCell>
//                     <StyledTableCell align="left" sx={tableHeadCellSx}>Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left" sx={tableHeadCellSx}>Tag No</StyledTableCell>
//                      <StyledTableCell align="left" sx={tableHeadCellSx}>Owner</StyledTableCell>
//                     {unit_id === -1 && <StyledTableCell align="left" sx={tableHeadCellSx}>Actual Qty</StyledTableCell>}
//                     <StyledTableCell align="right" sx={tableHeadCellSx}>Billing Qty</StyledTableCell>
//                     <StyledTableCell align="left" sx={tableHeadCellSx}>UOM</StyledTableCell>
                    
//                     <StyledTableCell align="center" sx={tableHeadCellSx} width="8%">Action</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ background: "#fff" }}>
//                   {table_details.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{index + 1}</StyledTableCell>
//                       <StyledTableCell align="left" sx={{ fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>
//                         {row.cyl_no}
//                       </StyledTableCell>


//                         <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
//     {row.tag_no || "—"}
//   </StyledTableCell>

//   {/* Owner — YE ADD KARO */}
//   <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
//     {row.owner || "—"}
//   </StyledTableCell>
//                       {unit_id === -1 && (
//                         <StyledTableCell align="right" sx={{ fontSize: "12px", color: "#2D3748" }}>
//                           {row.qty}
//                         </StyledTableCell>
//                       )}
//                       <StyledTableCell align="right">
//                         <TextField fullWidth size="small" variant="standard" type="number"
//                           placeholder="0" name="bill_qty" value={row.bill_qty}
//                           onChange={e => handleChangeInput(e, index)}
//                           sx={{ ...tableCellInputSx, "& input": { textAlign: "right", fontSize: "12px", padding: "4px 6px" } }}
//                           InputProps={{ disableUnderline: true }}
//                         />
//                       </StyledTableCell>
//                       <TextField
//   select size="small" fullWidth
//   name="uom"
//   value={row.uom || "CUM"}
//   onChange={e => handleChangeInput(e, index)}
//   variant="standard"
//   InputProps={{ disableUnderline: true }}
//   SelectProps={{ IconComponent: () => null }}
//   sx={{
//     "& .MuiSelect-select": { 
//       fontSize: "12px", 
//       textAlign: "left",
//       padding: "0px 20px",
//       marginTop:"10px",
//       paddingRight: "0px !important"
//     },
//    minWidth: "55px"
//   }}
// >
//   <MenuItem value="CUM" sx={{ fontSize: "12px" }}>CUM</MenuItem>
//   <MenuItem value="KGS" sx={{ fontSize: "12px" }}>KGS</MenuItem>
//   <MenuItem value="CYLINDER" sx={{ fontSize: "12px" }}>CYLINDER</MenuItem>
// </TextField>
//                       {/* <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
//                         {row.tag_no}
//                       </StyledTableCell> */}
//                       <StyledTableCell align="center">
//                         <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
//                           <IconButton size="small" onClick={handleAddRow}>
//                             <AddIcon sx={{ fontSize: 16, color: "#2B6CB0", border: "1px solid #2B6CB0", borderRadius: "50%" }} />
//                           </IconButton>
//                           <IconButton size="small" disabled={index === 0} onClick={() => handleRemoveDC(index)}>
//                             <DeleteForeverIcon sx={{ fontSize: 18, color: index === 0 ? "#c0c0c0" : "#E53E3E" }} />
//                           </IconButton>
//                         </Box>
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Totals */}
//             <Box sx={{ padding: "16px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0" }}>
//               <Grid container spacing={3} justifyContent="flex-end">
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Total Cylinders</Typography>
//                   <TextField size="small" fullWidth value={calculateTotalCylinders()}
//                     sx={readOnlyInputSx} InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <Typography sx={fieldLabelSx}>Total Quantity (CUM)</Typography>
//                   <TextField size="small" fullWidth value={calculateTotalQuantity().toFixed(2)}
//                     sx={readOnlyInputSx} InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//                 {editData && (
//                   <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "flex-end" }}>
//                     <FormControlLabel
//                       control={<Checkbox checked={checkboxValue === 1} onChange={e => setCheckboxValue(e.target.checked ? 1 : 0)} />}
//                       label={<Typography sx={{ fontSize: "13px", fontWeight: 600 }}>Update Check</Typography>}
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Footer */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//                <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         {/* ── Cylinder Selection Dialog ── */}
//         <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center" }}>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
//               Select Cylinders
//               <Box component="span" sx={{ ml: 1.5, px: 1.5, py: 0.3, background: "rgba(255,255,255,0.15)", borderRadius: "20px", fontSize: "12px" }}>
//                 {selectedCylinders.length} selected / {cylinder.length} available
//               </Box>
//             </Typography>
//           </Box>
//           <DialogContent sx={{ pt: 3 }}>
//             <Grid container spacing={1.5}>
//               {cylinder.map(cyl => {
//                 const isSelected = selectedCylinders.some(c => c.cylinder_no === cyl.cylinder_no);
//                 return (
//                   <Grid item xs={12} sm={6} md={4} lg={3} key={cyl.cylinder_no}>
//                     <Box
//                       onClick={() => handleCylinderSelect(cyl)}
//                       sx={{
//                         background: isSelected ? "#2B6CB0" : "#F7FAFC",
//                         color: isSelected ? "#fff" : "#2D3748",
//                         cursor: "pointer",
//                         borderRadius: 0,
//                         padding: "12px 14px",
//                         transition: "all 0.15s ease",
//                         border: isSelected ? "2px solid #2B6CB0" : "2px solid #E2E8F0",
//                         "&:hover": {
//                           background: isSelected ? "#2563A8" : "#EBF4FF",
//                           borderColor: "#2B6CB0",
//                         },
//                       }}
//                     >
//                       {/* Sequence: Cylinder No → Tag No → Owner */}
//                       <Typography sx={{ fontWeight: 700, fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", mb: 0.5 }}>
//                         {cyl.cylinder_no}
//                       </Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
//                         Tag: {cyl.tag_no || "—"}
//                       </Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
//                         Owner: {cyl.owner || "—"}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </DialogContent>
//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={() => setOpenDialog(false)} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogConfirm} sx={saveBtnSx}>Confirm Selection</Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(_, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top" horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default DeliveryChallanAdd;



import React, { useEffect, useState } from "react";
import {
  Box, Button, Typography, Grid, Paper, Table, TableContainer,
  TableHead, TableBody, IconButton, Dialog, DialogTitle,
  DialogContent, DialogActions, Card, CardContent, MenuItem,
  Autocomplete, TextField, Checkbox, FormControlLabel,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import deliveryChallanService from "../../../services/deliveryChallan.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import productMasterService from "../../../services/masters/productMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import suplierMasterService from "../../../services/masters/supplierMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import customerPoService from "../../../services/customerPo.Service";
import salesOrderService from "../../../services/sales_order";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";

// ── Styles ────────────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px", color: "#718096", mb: 2,
  display: "flex", alignItems: "center", gap: "6px",
};

const pageHeaderSx = {
  display: "flex", alignItems: "center",
  justifyContent: "space-between", mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px", fontWeight: 700, color: "#000",
  display: "flex", alignItems: "center", gap: "10px",
};

const backBtnSx = {
  display: "flex", alignItems: "center", gap: "6px",
  fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
  padding: "7px 14px", border: "1.5px solid #2B6CB0",
  borderRadius: "7px", background: "#fff", textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E", padding: "12px 22px",
  display: "flex", alignItems: "center", gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px", fontWeight: 600, color: "#2063b6",
  mb: "4px", display: "flex", alignItems: "center", gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa", height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readOnlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const datePickerSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa", height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
  },
  "& input": { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" },
};

const formFooterSx = {
  padding: "18px 24px", background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex", alignItems: "center",
  justifyContent: "flex-end", gap: "10px",
};

const saveBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#4CAF50",
  color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
  textTransform: "none", borderRadius: "8px",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#E53E3E",
  color: "#fff", border: "none", textTransform: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px", fontWeight: 600, borderRadius: "8px",
};

const tableHeadCellSx = {
  background: "#1C3A5E", color: "#fff",
  fontSize: "12px", fontWeight: 600,
  fontFamily: "'Inter', Arial, sans-serif",
  whiteSpace: "nowrap",
};

const tableCellInputSx = {
  "& .MuiInput-root": {
    fontSize: "12px",
    "&:before": { borderBottom: "none" },
    "&:after": { borderBottom: "none" },
    "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
  },
  "& input": { fontSize: "12px", padding: "4px 6px" },
};

// ─────────────────────────────────────────────────────────────────────────────

const formatDate = (date, inputFormat = null, outputFormat = "DD/MM/YYYY") => {
  if (!date) return "";
  const parsed = inputFormat ? dayjs(date, inputFormat) : dayjs(date);
  return parsed.isValid() ? parsed.format(outputFormat) : "";
};

const DeliveryChallanAdd = () => {
  const { handleSubmit } = useForm();
  const navigate = useNavigate();
  const urlLocation = useLocation();
  const editData = urlLocation?.state;

  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const loggedInDepotId = userInfo.depot_id;
  const from_depot_id = userInfo.depot_id;

  const [dcType, setDcType] = useState(
    editData ? (editData.to_depot_id ? "Depot" : editData.type || "Customer") : "Customer"
  );

  const [driver, setDriver] = useState([]);
  const [depot, setDepot] = useState([]);
  const [product, setProduct] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [schedule_entry, setScheduleEntry] = useState([]);
  const [sales_order, setSalesOrder] = useState([]);
  const [filteredPOs, setFilteredPOs] = useState([]);
  const [filteredSOs, setFilteredSOs] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCylinders, setSelectedCylinders] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [depot_name, setDepot_name] = useState([]);
  const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
  const [successMessage, setSuccessMessage] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(false);
  const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(false);

  // ── Field-level validation errors ──
  const [fieldErrors, setFieldErrors] = useState({});

useEffect(() => {
  async function fetchData() {
    try {
      const [
        driverData, depotData, productData, customerData, vehicleData,
        supplierData, scheduleEntryData, salesOrderData, cylinderData,
        delivercylindrData, deliverydepotData, deliverycustomer,
      ] = await Promise.all([
        driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
        depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
        productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
        customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
        vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
        suplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
        customerPoService.getScheduleEntryList({ page: 0, size: 999, searchKey: "" }),
        salesOrderService.getsalesorder({ page: 0, size: 999, searchKey: "" }),
        cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
        deliveryChallanService.getDeliverycylindernoList(depot_id),
        deliveryChallanService.getDeliveryChallandepotList(depot_id),
        deliveryChallanService.getDeliveryChallanCustomerList(depot_id),
      ]);

      // ... existing setters same rahenge
      const mergedDepotData = deliverydepotData.map(dd => ({
        ...dd,
        depot_name: depotData.find(d => d.depot_id === dd.depot_id)?.depot_name || "Unknown Depot",
      }));
      setDriver(driverData);
      setDepot(mergedDepotData);
      setProduct(productData);
      setVehicle(vehicleData);
      setSupplier(supplierData);
      setScheduleEntry(scheduleEntryData);
      setSalesOrder(salesOrderData);
      setCylinder(delivercylindrData);
      setDepot_name(depotData);
      setCustomer(deliverycustomer);

      if (editData) {
        // ... existing editData logic same rahega
      }

      // ✅ DC No Generation — sirf new entry ke liye
     if (!editData) {
  const dcList = await deliveryChallanService.getDeliveryChallanList({
    page: 0, size: 5, searchKey: "", depot_id: depot_id,
  });

  const yr = dayjs();
  const finYear = yr.month() >= 3
    ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
    : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

  // ✅ Same fin_year ki entries filter karo
  const sameYearEntries = dcList?.filter(d => d.entry_no?.includes(finYear)) ?? [];
  console.log("sameYearEntries:", sameYearEntries);

  const lastEntryNo = sameYearEntries?.[0]?.entry_no ?? "";
  console.log("lastEntryNo:", lastEntryNo);

  const parts = String(lastEntryNo).split("/");
  const lastSeq = parseInt(parts[parts.length - 1]) || 0;
  const nextSeq = lastSeq + 1;

  const formattedEntryNo = `DC/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
  console.log("Generated DC No:", formattedEntryNo);

  setData(prev => ({
    ...prev,
    entry_no: formattedEntryNo,
    fin_year: finYear,
  }));
}

    } catch (error) { console.error("Data fetching failed", error); }
  }
  fetchData();
}, []);

  const [data, setData] = useState({
    entry_no: editData?.entry_no || "",
    entry_date: editData ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
    so_no: editData?.so_no || "",
    so_date: editData?.so_date ? formatDate(editData.so_date, null, "YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
    po_no: editData?.po_no || "",
    po_date: editData?.po_date ? formatDate(editData.po_date, null, "YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
    to_depot_id: editData?.to_depot_id || "",
    to_customer_id: editData?.to_customer_id || "",
    vehicle_id: editData?.vehicle_id || "",
    driver_id: editData?.driver_id || "",
    driver_name: editData?.driver_name || "",
vehicle_no: editData?.vehicle_no || "",
    prepared_by: editData?.prepared_by || userInfo.full_name,
    table_details: editData?.table_details || "",
    delivery_address: editData?.delivery_address || "",
    contact_no: editData?.contact_no || "",
    invoice_no: editData?.invoice_no || "",
    fin_year: editData?.fin_year || "",
    from_depot_id: editData?.from_depot_id || "",
    unregistered_driver: editData?.unregistered_driver || "",
    unregistered_vehicle: editData?.unregistered_vehicle || "",
    type: editData?.dcType || "",
  });

  const [isUpdateArray, setIsUpdateArray] = useState(false);
  const [table_details, setTable_details] = useState(() => {
    if (editData) {
      try { return JSON.parse(editData.table_details); }
      catch { return [{ sr_no: "", cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }]; }
    }
    return [{ sr_no: "", cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }];
  });

  useEffect(() => {
    if (editData) {
      let newData = { ...editData };
      const prodId = editData.prod_id || editData.product_id;
      if (prodId) {
        const foundProduct = product.find(p => p.prod_id === prodId);
        if (foundProduct) {
          newData.prod_code = foundProduct.prod_code;
          newData.product_description = foundProduct.prod_description;
        }
      }
      setData(prev => ({ ...prev, ...newData }));
    }
  }, [editData, product]);

  useEffect(() => {
    setData(prev => ({ ...prev, type: dcType === "Depot" ? "depot" : "customer" }));
  }, [dcType]);

  const loggedInDepot = depot.find(d => d.depot_id === loggedInDepotId);

  useEffect(() => {
    if (!editData && loggedInDepot) {
      setData(prev => ({ ...prev, depot_id: loggedInDepotId, depot: loggedInDepot.depot_name || "Unknown Depot" }));
    }
  }, [editData, loggedInDepotId, loggedInDepot]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    let updatedFields = { [name]: value };

    if (["entry_date", "po_date", "so_date"].includes(name)) {
      updatedFields[name] = value ? formatDate(value, null, "YYYY-MM-DD") : "";
      if (name === "entry_date" && value) {
        const d = new Date(value);
        const m = d.getMonth(), y = d.getFullYear();
        updatedFields.fin_year = m >= 3 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
      }
    }
    if (name === "prod_code") {
      const p = product.find(p => p.prod_code === value);
      updatedFields.product_description = p?.prod_description || "";
      updatedFields.product_id = p?.prod_id || "";
    }
    if (name === "to_customer_id") {
      const c = customer.find(c => c.cust_id === value);
      if (c) {
        setFilteredPOs(schedule_entry.filter(po => po.customer_id === value || po.cust_id === value));
        updatedFields = { ...updatedFields, to_customer_id: c.cust_id, to_customer: c.cust_name, po_no: "", po_date: "", so_no: "", so_date: "", delivery_address: c.cust_address || "", contact_no: c.contact_no || "", invoice_no: c.invoice_no || "" };
      }
    }
    if (name === "po_no") {
      const po = filteredPOs.find(po => po.po_no === value);
      if (po) {
        setFilteredSOs(sales_order.filter(so => (so.customer_id === data.to_customer_id || so.cust_id === data.to_customer_id) && so.po_no === value));
        updatedFields = { ...updatedFields, po_date: formatDate(po.po_date, null, "YYYY-MM-DD") };
        if (!editData || editData.po_no !== value) { updatedFields.so_no = ""; updatedFields.so_date = ""; }
      }
    }
    if (name === "so_no") {
      const so = filteredSOs.find(so => so.so_no === value);
      if (so) updatedFields.so_date = formatDate(so.so_date, null, "YYYY-MM-DD");
    }
    if (name === "driver_id") {
      const d = driver.find(d => d.driver_id === value);
      updatedFields.driver_name = d ? d.driver_name : "";
    }
    if (name === "vehicle_id") {
      const v = vehicle.find(v => v.vehicle_id === value);
      updatedFields.vehicle_no = v ? v.vehicle_no : "";
    }
    setData(prev => ({ ...prev, ...updatedFields }));
  };

  const handleChangeInput = (e, i) => {
    const array = [...table_details];
    array[i] = { ...array[i], [e.target.name]: e.target.value, sr_no: i + 1 };
    setTable_details(array);
    setIsUpdateArray(p => !p);
    if (e.target.name === "bill_qty") {
      setFieldErrors(prev => ({ ...prev, billing_qty: false }));
    }
  };

  const handleRemoveDC = (index) => {
    const values = [...table_details];
    const removedCyl = values[index].cyl_no;
    values.splice(index, 1);
    setTable_details(values);
    setSelectedCylinders(prev => prev.filter(c => c.cylinder_no !== removedCyl));
    setIsUpdateArray(p => !p);
  };

  const handleAddRow = () => {
    setTable_details(prev => [...prev, { sr_no: prev.length + 1, cyl_no: "", qty: "", bill_qty: "", uom: "", prod_id: "", cyl_id: "", status: "", note: "" }]);
  };

  const handleCylinderSelect = (cyl) => {
    const already = selectedCylinders.find(c => c.cylinder_no === cyl.cylinder_no);
    setSelectedCylinders(already
      ? selectedCylinders.filter(c => c.cylinder_no !== cyl.cylinder_no)
      : [...selectedCylinders, { cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_id: cyl.prod_id, prod_code: cyl.prod_code, productDescription: cyl.prod_description || "", qty: cyl.qty || "1", bill_qty: "", uom: cyl.uom || "CUM", tag_no: cyl.tag_no || "", owner: cyl.owner || "",  status: cyl.status, level: cyl.level ?? cyl.note ?? "", note: cyl.level ?? cyl.note ?? ""}]
    );
  };

  const handleDialogConfirm = () => {
    setTable_details(selectedCylinders.map((cyl, i) => ({
      sr_no: i + 1, cyl_id: cyl.cyl_id, prod_id: cyl.prod_id,
      cyl_no: cyl.cylinder_no, tag_no: cyl.tag_no, owner: cyl.owner || "",prod_code: cyl.prod_code,
      product_description: cyl.productDescription, qty: cyl.qty,
      bill_qty: "", uom: cyl.uom, status: cyl.status, level: cyl.level ?? cyl.note ?? "", note: cyl.level ?? cyl.note ?? "",
    })));
    setIsUpdateArray(p => !p);
    setOpenDialog(false);
    setFieldErrors(prev => ({ ...prev, no_cylinders: false }));
  };

  // ── Validation: returns both a field-error map and human-readable messages ──
  const validategetForm = () => {
    const errors = {};
    const messages = [];

    if (dcType === "Customer" && !data.to_customer_id) {
      errors.to_customer_id = true;
      messages.push("Customer");
    }
    if (dcType === "Depot" && !data.to_depot_id) {
      errors.to_depot_id = true;
      messages.push("Depot");
    }
    if (!data.vehicle_id && !data.unregistered_vehicle) {
      errors.vehicle_no = true;
      messages.push("Vehicle No");
    }
    if (!data.driver_id && !data.unregistered_driver) {
      errors.driver_name = true;
      messages.push("Driver Name");
    }
    if (!data.prod_code) {
      errors.prod_code = true;
      messages.push("Product Code");
    }
 if (dcType !== "Depot" && !data.invoice_no) {
  errors.invoice_no = true;
  messages.push("Invoice No");
}
    if (table_details.filter(row => row.cyl_no && row.cyl_no.trim() !== "").length === 0) {
      errors.no_cylinders = true;
      messages.push("Select at least one Cylinder");
    }
    if (dcType !== "Depot" && table_details.some(row => row.cyl_no && row.cyl_no.trim() !== "" && (!row.bill_qty || parseFloat(row.bill_qty) <= 0))) {
  errors.billing_qty = true;
  messages.push("Billing Qty for each selected cylinder");
}

    return { errors, messages };
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;
    const { errors, messages } = validategetForm();
    if (messages.length > 0) {
      setFieldErrors(errors);
      setSuccessMessage(`Please fill: ${messages.join(", ")}`);
      setOpenSnackbar(true);
      setTimeout(() => { setOpenSnackbar(false); setSuccessMessage(""); }, 5000);
      return;
    }
    setFieldErrors({});
    setIsSubmitting(true);
    const dcData = {
      ...data, entry_id: editData ? editData.entry_id : undefined,
      modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      created_by: editData ? editData.created_by : userInfo.user_id,
      table_details: JSON.stringify(table_details || []),
      changedUpdatedValue: "edit", unit_id, short_code, from_depot_id,
      update_check: checkboxValue,
    };
    try {
      editData
        ? await deliveryChallanService.editDeleteDeliveryChallan(dcData)
        : await deliveryChallanService.addDeliveryChallan(dcData);
      setSuccessMessage(editData ? "Delivery Challan updated successfully" : "Delivery Challan added successfully");
      setOpenSnackbar(true);
      setTimeout(() => { setOpenSnackbar(false); navigate(-1); }, 2000);
    } catch (error) {
      setSuccessMessage("Error saving delivery challan");
      setOpenSnackbar(true);
      setTimeout(() => { setOpenSnackbar(false); }, 3000);
      setIsSubmitting(false);
    }
  };

  const calculateTotalCylinders = () => table_details.filter(r => r.cyl_no && r.cyl_no.trim() !== "").length;
  const calculateTotalQuantity = () => table_details.reduce((t, r) => t + (parseFloat(r.bill_qty) || 0), 0);

  const toggleUnregisteredDriver = () => {
    setShowUnregisteredDriver(p => !p);
    if (showUnregisteredDriver) handleChange({ target: { name: "unregistered_driver", value: "" } });
  };
  const toggleUnregisteredVehicle = () => {
    setShowUnregisteredVehicle(p => !p);
    if (showUnregisteredVehicle) handleChange({ target: { name: "unregistered_vehicle", value: "" } });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>
        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Delivery Challan</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <LocalShippingIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} DELIVERY CHALLAN
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* ── Delivery Challan Details Card ── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>DELIVERY CHALLAN DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              {/* Two-column container — same as Cylinder Inward */}
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* ════ LEFT COLUMN ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}
                >
                  <Grid container spacing={1.5}>

                    {/* From Location */}
                    {/* <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>From Location</Typography>
                      <TextField size="small" fullWidth
                        value={depot_name.find(d => d.depot_id === loggedInDepotId)?.depot_name || "Unknown Depot"}
                        sx={readOnlyInputSx}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid> */}

                    {/* To Location Type */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>To Location</Typography>
                      <Autocomplete
                        disablePortal options={["Customer", "Depot"]} value={dcType}
                        onChange={(_, newVal) => {
                          setDcType(newVal);
                          setData(prev => ({
                            ...prev, type: newVal === "Depot" ? "depot" : "customer",
                            to_supplier: "", to_supplier_id: "", to_customer_id: "", to_depot_id: "",
                            po_no: "", po_date: "", so_no: "", so_date: "",
                            delivery_address: "", contact_no: "", invoice_no: "",
                          }));
                          setFieldErrors(prev => ({ ...prev, to_customer_id: false, to_depot_id: false }));
                        }}
                        renderInput={params => (
                          <TextField {...params} size="small" fullWidth sx={inputSx}
                            inputProps={{ ...params.inputProps, readOnly: true }}
                          />
                        )}
                      />
                    </Grid>

                    {/* Customer or Depot */}
                    {dcType === "Customer" ? (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>Customer <span style={{ color: "#E53E3E" }}>*</span></Typography>
                        <Autocomplete
                          disablePortal options={customer || []}
                          getOptionLabel={opt => typeof opt === "string" ? opt : opt.cust_name || ""}
                          value={customer.find(c => c.cust_id === data.to_customer_id) || null}
                          onChange={(_, newVal) => {
                            handleChange({ target: { name: "to_customer_id", value: newVal?.cust_id ?? null } });
                            setFieldErrors(prev => ({ ...prev, to_customer_id: false }));
                          }}
                          isOptionEqualToValue={(opt, val) => opt.cust_id === val?.cust_id}
                          renderInput={params => (
                            <TextField {...params} size="small" fullWidth sx={inputSx}
                              error={!!fieldErrors.to_customer_id}
                              helperText={fieldErrors.to_customer_id ? "Customer is required" : ""}
                              FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                            />
                          )}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>Depot <span style={{ color: "#E53E3E" }}>*</span></Typography>
                        <Autocomplete
                          disablePortal options={depot || []}
                          getOptionLabel={opt => typeof opt === "string" ? opt : opt.depot_name || ""}
                          value={depot.find(d => d.depot_id === data.to_depot_id) || null}
                          onChange={(_, newVal) => {
                            handleChange({ target: { name: "to_depot_id", value: newVal ? newVal.depot_id : null } });
                            setFieldErrors(prev => ({ ...prev, to_depot_id: false }));
                          }}
                          isOptionEqualToValue={(opt, val) => opt.depot_id === val?.depot_id}
                          renderInput={params => (
                            <TextField {...params} size="small" fullWidth sx={inputSx}
                              error={!!fieldErrors.to_depot_id}
                              helperText={fieldErrors.to_depot_id ? "Depot is required" : ""}
                              FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                            />
                          )}
                        />
                      </Grid>
                    )}

                    {/* Delivery Address — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>Delivery Address</Typography>
                        <TextField size="small" fullWidth name="delivery_address"
                          value={data.delivery_address || ""} sx={readOnlyInputSx}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {/* Contact No — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>Contact No</Typography>
                       <TextField
  size="small"
  fullWidth
  name="contact_no"
  value={data.contact_no || ""}
  onChange={handleChange}
  sx={inputSx} // ya readOnlyInputSx agar sirf styling hai
/>
                      </Grid>
                    )}

                    {/* Driver Name */}
                   

                    {/* Select Cylinders Button */}
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        onClick={() => setOpenDialog(true)}
                        startIcon={<AddIcon />}
                        sx={{
                          background: "#2B6CB0", color: "#fff", fontWeight: 600,
                          fontSize: "13px", px: 3, height: "36px", borderRadius: "8px",
                          textTransform: "none", "&:hover": { background: "#04407d" },
                        }}
                      >
                        Select Cylinders
                      </Button>
                      {fieldErrors.no_cylinders && (
                        <Typography sx={{ fontSize: "11px", color: "#E53E3E", mt: 0.5 }}>
                          Please select at least one cylinder
                        </Typography>
                      )}
                    </Grid>

                  </Grid>
                </Grid>

                {/* ════ RIGHT COLUMN ════ */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC" }}>
                  <Grid container spacing={1.5}>

                    {/* DC No */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>DC No</Typography>
                      <TextField size="small" fullWidth name="entry_no"
                        value={data.entry_no} sx={readOnlyInputSx}
                        InputProps={{ readOnly: true }} placeholder="Auto-generated"
                      />
                    </Grid>

                    {/* DC Date */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>DC Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker format="DD/MM/YYYY"
                        value={data.entry_date ? dayjs(data.entry_date) : null}
                        onChange={v => handleChange({ target: { name: "entry_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                        sx={datePickerSx}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
                      />
                    </Grid>

                    {/* PO No — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>PO No</Typography>
                        <Autocomplete disablePortal options={filteredPOs} clearIcon={false}
                          getOptionLabel={opt => typeof opt === "string" ? opt : opt.po_no || ""}
                          value={filteredPOs.find(po => po.po_no === data.po_no) || (editData?.po_no ? { po_no: editData.po_no } : null)}
                          onChange={(_, v) => handleChange({ target: { name: "po_no", value: v ? v.po_no : "" } })}
                          isOptionEqualToValue={(opt, val) => opt.po_no === val.po_no}
                          renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
                        />
                      </Grid>
                    )}

                    {/* PO Date — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>PO Date</Typography>
                        <DatePicker format="DD/MM/YYYY"
                          value={data.po_date ? dayjs(data.po_date) : null}
                          onChange={v => handleChange({ target: { name: "po_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                          sx={datePickerSx}
                          slotProps={{ textField: { size: "small", fullWidth: true } }}
                        />
                      </Grid>
                    )}

                    {/* SO No — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>SO No</Typography>
                        <Autocomplete disablePortal options={filteredSOs} clearIcon={false}
                          disabled={!data.po_no}
                          getOptionLabel={opt => typeof opt === "string" ? opt : opt.so_no || ""}
                          value={filteredSOs.find(so => so.so_no === data.so_no) || (editData?.so_no ? { so_no: editData.so_no } : null)}
                          onChange={(_, v) => handleChange({ target: { name: "so_no", value: v ? v.so_no : "" } })}
                          isOptionEqualToValue={(opt, val) => opt.so_no === val.so_no}
                          renderInput={params => <TextField {...params} size="small" fullWidth sx={inputSx} />}
                        />
                      </Grid>
                    )}

                    {/* SO Date — Customer only */}
                    {dcType === "Customer" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={fieldLabelSx}>SO Date</Typography>
                        <DatePicker format="DD/MM/YYYY"
                          value={data.so_date ? dayjs(data.so_date) : null}
                          onChange={v => handleChange({ target: { name: "so_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                          sx={datePickerSx}
                          slotProps={{ textField: { size: "small", fullWidth: true } }}
                        />
                      </Grid>
                    )}


                     <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Driver Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Autocomplete freeSolo disablePortal options={driver || []} clearIcon={false} sx={{ flex: 1 }}
  getOptionLabel={opt => typeof opt === "string" ? opt : opt.driver_name || ""}
  value={driver.find(d => d.driver_id === data.driver_id) || data.driver_name || null}
  onChange={(_, newValue) => {
    if (newValue && typeof newValue === "object") {
      handleChange({ target: { name: "driver_id", value: newValue.driver_id } });
      handleChange({ target: { name: "driver_name", value: newValue.driver_name } });
      handleChange({ target: { name: "unregistered_driver", value: "" } });
    } else if (typeof newValue === "string") {
      handleChange({ target: { name: "driver_id", value: "" } });
      handleChange({ target: { name: "driver_name", value: newValue } });
      handleChange({ target: { name: "unregistered_driver", value: newValue } });
    } else {
      handleChange({ target: { name: "driver_id", value: "" } });
      handleChange({ target: { name: "driver_name", value: "" } });
      handleChange({ target: { name: "unregistered_driver", value: "" } });
    }
    setFieldErrors(prev => ({ ...prev, driver_name: false }));
  }}
  onInputChange={(event, inputValue, reason) => {
    if (reason === "input") {
      const matched = driver.find(d => d.driver_name?.toLowerCase() === inputValue?.toLowerCase());
      if (!matched) {
        handleChange({ target: { name: "driver_id", value: "" } });
        handleChange({ target: { name: "driver_name", value: inputValue } });
        handleChange({ target: { name: "unregistered_driver", value: inputValue } });
      }
      setFieldErrors(prev => ({ ...prev, driver_name: false }));
    }
  }}
  isOptionEqualToValue={(opt, val) => opt.driver_id === val?.driver_id}
  renderInput={params => (
    <TextField {...params} size="small" fullWidth placeholder="Select or type driver name" sx={inputSx}
      error={!!fieldErrors.driver_name}
      helperText={fieldErrors.driver_name ? "Driver Name is required" : ""}
      FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
    />
  )}
/>
                        {/* <IconButton onClick={toggleUnregisteredDriver} sx={{ border: "1px solid #2B6CB0", borderRadius: "8px", p: "6px", width: "36px", height: "36px" }}>
                          <AddIcon sx={{ fontSize: 18, color: "#2B6CB0" }} />
                        </IconButton> */}
                      </Box>
                      {/* {showUnregisteredDriver && (
                        <Box sx={{ mt: 1 }}>
                          <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unregistered Driver</Typography>
                          <TextField size="small" fullWidth name="unregistered_driver"
                            value={data.unregistered_driver || ""}
                            onChange={e => { handleChange(e); if (e.target.value) handleChange({ target: { name: "driver_id", value: "" } }); }}
                            sx={inputSx} placeholder="Enter driver name"
                          />
                        </Box>
                      )} */}
                    </Grid>

                    {/* Vehicle No */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Vehicle No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                       <Autocomplete freeSolo disablePortal options={vehicle || []} clearIcon={false} sx={{ flex: 1 }}
  getOptionLabel={opt => typeof opt === "string" ? opt : opt.vehicle_no || ""}
  value={vehicle.find(v => v.vehicle_id === data.vehicle_id) || data.vehicle_no || null}
  onChange={(_, newValue) => {
    if (newValue && typeof newValue === "object") {
      handleChange({ target: { name: "vehicle_id", value: newValue.vehicle_id } });
      handleChange({ target: { name: "vehicle_no", value: newValue.vehicle_no } });
      handleChange({ target: { name: "unregistered_vehicle", value: "" } });
    } else if (typeof newValue === "string") {
      handleChange({ target: { name: "vehicle_id", value: "" } });
      handleChange({ target: { name: "vehicle_no", value: newValue } });
      handleChange({ target: { name: "unregistered_vehicle", value: newValue } });
    } else {
      handleChange({ target: { name: "vehicle_id", value: "" } });
      handleChange({ target: { name: "vehicle_no", value: "" } });
      handleChange({ target: { name: "unregistered_vehicle", value: "" } });
    }
    setFieldErrors(prev => ({ ...prev, vehicle_no: false }));
  }}
  onInputChange={(event, inputValue, reason) => {
    if (reason === "input") {
      const matched = vehicle.find(v => v.vehicle_no?.toLowerCase() === inputValue?.toLowerCase());
      if (!matched) {
        handleChange({ target: { name: "vehicle_id", value: "" } });
        handleChange({ target: { name: "vehicle_no", value: inputValue } });
        handleChange({ target: { name: "unregistered_vehicle", value: inputValue } });
      }
      setFieldErrors(prev => ({ ...prev, vehicle_no: false }));
    }
  }}
  isOptionEqualToValue={(opt, val) => opt.vehicle_id === val?.vehicle_id}
  renderInput={params => (
    <TextField {...params} size="small" fullWidth placeholder="Select or type vehicle no" sx={inputSx}
      error={!!fieldErrors.vehicle_no}
      helperText={fieldErrors.vehicle_no ? "Vehicle No is required" : ""}
      FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
    />
  )}
/>

                        {/* <IconButton onClick={toggleUnregisteredVehicle} sx={{ border: "1px solid #2B6CB0", borderRadius: "8px", p: "6px", width: "36px", height: "36px" }}>
                          <AddIcon sx={{ fontSize: 18, color: "#2B6CB0" }} />
                        </IconButton> */}
                      </Box>
                      {/* {showUnregisteredVehicle && (
                        <Box sx={{ mt: 1 }}>
                          <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unregistered Vehicle</Typography>
                          <TextField size="small" fullWidth name="unregistered_vehicle"
                            value={data.unregistered_vehicle || ""}
                            onChange={e => { handleChange(e); if (e.target.value) handleChange({ target: { name: "vehicle_id", value: "" } }); }}
                            sx={inputSx} placeholder="Enter vehicle number"
                          />
                        </Box>
                      )} */}
                    </Grid>

                    {/* Invoice No */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Invoice No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <TextField size="small" fullWidth name="invoice_no"
                        value={data.invoice_no}
                        onChange={e => { handleChange(e); setFieldErrors(prev => ({ ...prev, invoice_no: false })); }}
                        placeholder="Enter invoice number" sx={inputSx}
                        error={!!fieldErrors.invoice_no}
                        helperText={fieldErrors.invoice_no ? "Invoice No is required" : ""}
                        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                      />
                    </Grid>

                    {/* Prepared By */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Prepared By</Typography>
                      <TextField size="small" fullWidth name="prepared_by"
                        value={data.prepared_by} sx={readOnlyInputSx}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>

                    {/* Product Code */}
                    <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Product Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <Autocomplete disablePortal options={product || []} clearIcon={false}
                       componentsProps={{
                          popper: {
                            placement: "bottom-start",
                            modifiers: [{ name: "flip", enabled: false }],
                          },
                        }}
                        getOptionLabel={opt => typeof opt === "string" ? opt : opt.prod_code || ""}
                        value={product.find(p => p.prod_code === data.prod_code) || (data.prod_code ? { prod_code: data.prod_code } : null)}
                        onChange={(_, v) => {
                          handleChange({ target: { name: "prod_code", value: v ? v.prod_code : "" } });
                          setFieldErrors(prev => ({ ...prev, prod_code: false }));
                        }}
                        isOptionEqualToValue={(opt, val) => opt.prod_code === val.prod_code}
                        renderInput={params => (
                          <TextField {...params} size="small" fullWidth sx={inputSx}
                            error={!!fieldErrors.prod_code}
                            helperText={fieldErrors.prod_code ? "Product Code is required" : ""}
                            FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
                          />
                        )}
                      />
                    </Grid>

                    {/* Product Description */}
                    {/* <Grid item xs={12} sm={6}>
                      <Typography sx={fieldLabelSx}>Product Description</Typography>
                      <TextField size="small" fullWidth name="product_description"
                        value={data.product_description || ""} sx={readOnlyInputSx}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid> */}

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ── Cylinder Table ── */}
          <Box sx={formCardSx}>
            <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: "none" }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center" sx={tableHeadCellSx} width="6%">Sr No</StyledTableCell>
                    <StyledTableCell align="left" sx={tableHeadCellSx}>Cylinder No</StyledTableCell>
                    <StyledTableCell align="left" sx={tableHeadCellSx}>Tag No</StyledTableCell>
                     <StyledTableCell align="left" sx={tableHeadCellSx}>Owner</StyledTableCell>
                    {unit_id === -1 && <StyledTableCell align="left" sx={tableHeadCellSx}>Actual Qty</StyledTableCell>}
{dcType !== "Depot" && (
  <StyledTableCell align="right" sx={tableHeadCellSx}>Billing Qty</StyledTableCell>
)}
{dcType !== "Depot" && (
  <StyledTableCell align="left" sx={tableHeadCellSx}>UOM</StyledTableCell>
)}

<StyledTableCell align="center" sx={tableHeadCellSx} width="8%">Action</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody sx={{ background: "#fff" }}>
                  {table_details.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{index + 1}</StyledTableCell>
                      <StyledTableCell align="left" sx={{ fontSize: "12px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>
                        {row.cyl_no}
                      </StyledTableCell>


                        <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
    {row.tag_no || "—"}
  </StyledTableCell>

  {/* Owner — YE ADD KARO */}
  <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
    {row.owner || "—"}
  </StyledTableCell>
                {unit_id === -1 && (
  <StyledTableCell align="right" sx={{ fontSize: "12px", color: "#2D3748" }}>
    {row.qty}
  </StyledTableCell>
)}
{dcType !== "Depot" && (
  <StyledTableCell align="right">
    <TextField fullWidth size="small" variant="standard" type="number"
      placeholder="0" name="bill_qty" value={row.bill_qty}
      onChange={e => handleChangeInput(e, index)}
      error={fieldErrors.billing_qty && row.cyl_no && row.cyl_no.trim() !== "" && (!row.bill_qty || parseFloat(row.bill_qty) <= 0)}
      helperText={
        fieldErrors.billing_qty && row.cyl_no && row.cyl_no.trim() !== "" && (!row.bill_qty || parseFloat(row.bill_qty) <= 0)
          ? "Billing Qty is required"
          : ""
      }
      FormHelperTextProps={{ sx: { fontSize: "10px", color: "#E53E3E", textAlign: "right", m: 0 } }}
      sx={{
        ...tableCellInputSx,
        "& input": { textAlign: "right", fontSize: "12px", padding: "4px 6px" },
      }}
      InputProps={{ disableUnderline: true }}
    />
  </StyledTableCell>
)}
{dcType !== "Depot" && (
  <StyledTableCell align="left">
    <TextField
      select size="small" fullWidth
      name="uom"
      value={row.uom || "CUM"}
      onChange={e => handleChangeInput(e, index)}
      variant="standard"
      InputProps={{ disableUnderline: true }}
      SelectProps={{ IconComponent: () => null }}
      sx={{
        "& .MuiSelect-select": { 
          fontSize: "12px", 
          textAlign: "left",
          padding: "0px 20px",
          marginTop:"10px",
          paddingRight: "0px !important"
        },
       minWidth: "55px"
      }}
    >
      <MenuItem value="CUM" sx={{ fontSize: "12px" }}>CUM</MenuItem>
      <MenuItem value="KGS" sx={{ fontSize: "12px" }}>KGS</MenuItem>
      <MenuItem value="CYLINDER" sx={{ fontSize: "12px" }}>CYLINDER</MenuItem>
    </TextField>
  </StyledTableCell>
)}
                      {/* <StyledTableCell align="left" sx={{ fontSize: "12px", color: "#2D3748" }}>
                        {row.tag_no}
                      </StyledTableCell> */}
                      <StyledTableCell align="center">
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                          <IconButton size="small" onClick={handleAddRow}>
                            <AddIcon sx={{ fontSize: 16, color: "#2B6CB0", border: "1px solid #2B6CB0", borderRadius: "50%" }} />
                          </IconButton>
                          <IconButton size="small" disabled={index === 0} onClick={() => handleRemoveDC(index)}>
                            <DeleteForeverIcon sx={{ fontSize: 18, color: index === 0 ? "#c0c0c0" : "#E53E3E" }} />
                          </IconButton>
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Totals */}
            <Box sx={{ padding: "16px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0" }}>
              <Grid container spacing={3} justifyContent="flex-end">
                <Grid item xs={12} md={3}>
                  <Typography sx={fieldLabelSx}>Total Cylinders</Typography>
                  <TextField size="small" fullWidth value={calculateTotalCylinders()}
                    sx={readOnlyInputSx} InputProps={{ readOnly: true }}
                  />
                </Grid>
               {dcType !== "Depot" && (
                  <Grid item xs={12} md={3}>
                    <Typography sx={fieldLabelSx}>Total Quantity (CUM)</Typography>
                    <TextField size="small" fullWidth value={calculateTotalQuantity().toFixed(2)}
                      sx={readOnlyInputSx} InputProps={{ readOnly: true }}
                    />
                  </Grid>
                )}
                {editData && (
                  <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "flex-end" }}>
                    <FormControlLabel
                      control={<Checkbox checked={checkboxValue === 1} onChange={e => setCheckboxValue(e.target.checked ? 1 : 0)} />}
                      label={<Typography sx={{ fontSize: "13px", fontWeight: 600 }}>Update Check</Typography>}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Footer */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
               <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </form>

        {/* ── Cylinder Selection Dialog ── */}
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth
          PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
              Select Cylinders
              <Box component="span" sx={{ ml: 1.5, px: 1.5, py: 0.3, background: "rgba(255,255,255,0.15)", borderRadius: "20px", fontSize: "12px" }}>
                {selectedCylinders.length} selected / {cylinder.length} available
              </Box>
            </Typography>
          </Box>
          <DialogContent sx={{ pt: 3 }}>
            <Grid container spacing={1.5}>
              {cylinder.map(cyl => {
                const isSelected = selectedCylinders.some(c => c.cylinder_no === cyl.cylinder_no);
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={cyl.cylinder_no}>
                    <Box
                      onClick={() => handleCylinderSelect(cyl)}
                      sx={{
                        background: isSelected ? "#2B6CB0" : "#F7FAFC",
                        color: isSelected ? "#fff" : "#2D3748",
                        cursor: "pointer",
                        borderRadius: 0,
                        padding: "12px 14px",
                        transition: "all 0.15s ease",
                        border: isSelected ? "2px solid #2B6CB0" : "2px solid #E2E8F0",
                        "&:hover": {
                          background: isSelected ? "#2563A8" : "#EBF4FF",
                          borderColor: "#2B6CB0",
                        },
                      }}
                    >
                      {/* Sequence: Cylinder No → Tag No → Owner */}
                      <Typography sx={{ fontWeight: 700, fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", mb: 0.5 }}>
                        {cyl.cylinder_no}
                      </Typography>
                      <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
                        Tag: {cyl.tag_no || "—"}
                      </Typography>
                      <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
                        Owner: {cyl.owner || "—"}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button onClick={() => setOpenDialog(false)} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleDialogConfirm} sx={saveBtnSx}>Confirm Selection</Button>
          </DialogActions>
        </Dialog>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(_, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top" horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DeliveryChallanAdd;





